module.exports = __webpack_public_path__ + "static/media/burns_copeland_durnin.ca0eea7c.gif";